"use client";

import { api } from "@/lib/api-client";
import { useCurrentUser } from "./use-current-user";

/** Sender display and form gates use the same authorized principal as the send. */
export function useInquirySender() {
  const auth = useCurrentUser();
  const query = api.listings.getInquirySender.useQuery(undefined, {
    enabled: Boolean(auth.user),
    retry: false,
    staleTime: 5_000,
  });
  return {
    ...auth,
    user: auth.user ? (query.data ?? null) : null,
    loaded: auth.loaded && (!auth.user || query.isSuccess || query.isError),
    signedIn: Boolean(auth.user),
    senderError: query.error,
    delegated: query.data?.delegated ?? false,
  };
}
